<template>
  <div v-if="session.session_logo_url">

    <!-- logo left: start -->
    <div v-if="session.logo_position == 'left'" class="flex items-end my-8">
      <div class="mr-4">
        <img :src="session.session_logo_url" alt="Logo" class="w-auto" :class="logoSize">
      </div>
      <div class="flex-grow border-t border-gray-400"></div>
    </div>
    <!-- logo left: end -->


    <!-- logo right: start -->
    <div v-else-if="session.logo_position == 'right'" class="flex items-end my-8">
      <div class="flex-grow border-t border-gray-400"></div>
      <div class="ml-4">
        <img :src="session.session_logo_url" alt="Logo" class="w-auto" :class="logoSize">
      </div>
    </div>
    <!-- logo right: end -->


    <!-- logo centered: start -->
    <div v-else class="flex items-end justify-center my-8">
      <div class="flex-grow border-t border-gray-400"></div>
      <div class="mx-4">
        <img :src="session.session_logo_url" alt="Logo" class="w-auto" :class="logoSize">
      </div>
      <div class="flex-grow border-t border-gray-400"></div>
    </div>
    <!-- logo centered: end -->

  </div>
</template>

<script>
export default {
  props: {
    session: {
      type: Object,
      required: true,
    },
  },

  computed: {
    logoSize() {
      if (this.session.logo_size == 'l') {
        return 'h-14';
      }

      if (this.session.logo_size == 's') {
        return 'h-10';
      }

      return 'h-12';
    },
  },
};
</script>
